export default {
    customerStatus: {
        title: 'APM Monaco 수리 요청',
        apmSale: '애프터 서비스',
        customerName: '고객 이름',
        shopName: '매장',
        shopPhone: '매장 전화',
        shopEmail: '이메일 주소',
        created: '생성됨',
        productReference: '품목 번호',
        repairFee: '수리비',
        repairReason: '수리 사유',
        clickText: '수리 과정을 조회려면 여기를 클릭하세요',
        enjoyText: 'www.apm.mc에서 쇼핑을 즐기세요',
        tipsText: '연중무휴 하루 24시간 서비스를 이용하실 수 있습니다.',
        step1Title: '1단계',
        step2Title: '2단계',
        step3Title: '3단계',
        step4Title: '4단계',
        step5Title: '5단계',
        step6Title: '6단계',
        step1Content: 'APM 부티크에 맡김',
        step2Content: '수리 센터로 이동',
        step3Content: '수리 센터',
        step4Content: 'APM 부티크로 이동',
        step5Content: '픽업 준비 완료',
        step6Content: '픽업됨',
        orderID: '주문 번호',
        orderName: '주문 ID',
        trackingNumber: '조회 번호',
        userName: '이름',
        userEmail: '이메일',
        userPhone: '전화',
        ccStep1Title: '1단계',
        ccStep2Title: '2단계',
        ccStep3Title: '3단계',
        ccStep4Title: '4단계',
        ccStep5Title: '5단계',
        ccStep6Title: '6단계',
        ccStep1Content: '추적 번호 대기 중',
        ccStep2Content: '수리 센터로 운송 중',
        ccStep3Content: '수리 센터',
        ccStep4Content: '수리 완료',
        ccStep5Content: '고객에게 배송 중',
        ccStep6Content: '배송 완료',
    },
};